export const ENDPOINTS = {
  editReview: '/gateway/admin/reviews/:reviewId',
  publishReview: '/gateway/admin/reviews/:reviewId/publish',
  unpublishReview: '/gateway/admin/reviews/:reviewId/unpublish',
} as const;

export const CORE_QUERY_KEYS = {
  review: 'admin-booking-review',
} as const;
